module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n")
    ;  /* Each current page renders on this stack of elements.
    * The drop shadow div renders behind and offset from  the canvases.
    * We don't render anything on a bottom page canvas except its color propety and optional gridlines.
    * HTML control elements float above the canvases, driven by z-index.
    * No controls are drawn on a canvas. Controls are HTML elements.
    * Teh transparent second canvas can display a user-driven multi-selection rectangle.
    */ 
    ; __append("\r\n<!-- a page --> \r\n<div id=\"aPage\" class=\"page-background disable-select\" draggable=\"false\"  tabindex=\"3\" style=\"z-index: 0;\">\r\n\r\n\r\n    <canvas id=\"aPageSel\"   class=\"page-selection-background pf-control has-menu\" draggable=\"false\"\r\n            tabindex=\"4\" style=\"overflow: scroll; z-index: ")
    ; __append(escapeFn( zIndex ))
    ; __append(";\"> This browser does not support the HTML5 canvas tag. HTML canvas.</canvas>\r\n</div>\r\n\r\n<!-- 0..n controls -->\r\n")
  }
  return __output;

}